<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.convert.title"|translate}}</h4>
    <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close"
            title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="dismiss()">
      <span class="icon-Close" aria-hidden="true" ></span>
    </button>
  </div>
  <div class="modal-body convert-modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>

    <div class="col-12">
      <form #planSettingsForm="ngForm" (submit)="submit()">
        <div class="row group-title">
          <div class='col-12'>
            <span class="primary-text">{{planName}}</span>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="text-uppercase input-label" for="sourceFrom">
                {{"plan.convert.from"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="sourceFrom"
                        #sourceFromCalendarEl
                        [showIcon]="true"
                        [minDate]="_planStartDate"
                        [maxDate]="_planEndDate"
                        [keepInvalid]="true"
                        [showOtherMonths]="true"
                        (onClose)="onSourceFromChanged()"
                        (onInput)="onSourceFromChanged()"
                        (onSelect)="onSourceFromChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        ngbAutofocus
                        [(ngModel)]="_sourceFrom"
                        title="{{'plan.convert.calendar.tooltip'|translate}}" tooltipPosition="right">
            </p-datepicker>
            <div *ngIf="_showSourceFromValidationError" class="error-message">
              {{'plan.convert.source.from.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="text-uppercase input-label" for="sourceTo">
                {{"plan.convert.to"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="sourceTo"
                        #sourceToCalendarEl
                        [showIcon]="true"
                        [minDate]="_planStartDate"
                        [keepInvalid]="true"
                        [maxDate]="_planEndDate"
                        (onClose)="onSourceToChanged()"
                        (onInput)="onSourceToChanged()"
                        (onSelect)="onSourceToChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        [(ngModel)]="_sourceTo"
                        title="{{'plan.convert.calendar.tooltip'|translate}}" >
            </p-datepicker>
            <div *ngIf="_showSourceToValidationError" class="error-message">
              {{'plan.convert.source.to.validation'|translate}}
            </div>
            <div *ngIf="_showSourceToRangeValidationError" class="error-message">
              {{'plan.convert.source.to.range.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row separator">

        </div>
        <div class="row  group-title">
          <div class='col-12'>
            <span class="primary-text">{{"plan.convert.active.forecast.label"|translate}}</span>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="text-uppercase input-label" for="targetFrom">
                {{"plan.convert.from"|translate}} <span class="text-danger">*</span>
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="targetFrom"
                        #targetFromCalendarEl
                        [showIcon]="true"
                        [minDate]="_targetFromMin"
                        [keepInvalid]="true"
                        (onInput)="onTargetFromChanged()"
                        (onSelect)="onTargetFromChanged()"
                        [dateFormat]="_datesFormat"
                        readonlyInput="true"
                        [(ngModel)]="_targetFrom"
                        title="{{'plan.convert.calendar.tooltip'|translate}}">
            </p-datepicker>
            <div *ngIf="_showTargetFromValidationError" class="error-message">
              {{'plan.convert.target.from.validation'|translate}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 '>
            <div>
              <label class="text-uppercase input-label" for="targetTo">
                {{"plan.convert.to"|translate}}
              </label>
            </div>
            <p-datepicker class="wfm-form-control form-control-inline"
                        name="targetTo"
                        [showIcon]="true"
                        [disabled]="true"
                        [dateFormat]="_datesFormat"
                        [(ngModel)]="_targetTo">
            </p-datepicker>
          </div>
        </div>
        <div class="row warning-message" [ngClass]="{'invisible':_forecastIsSameDay}">
          <div class='col-12'>
            <span>
              <i class="icon-system_warning"></i>
              {{"plan.convert.warning.date.range.begin.diff.days"|translate}}
            </span>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     [showTooltip]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.convert.btn'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     [showTooltip]="true"
                     placement="top"
                     [ngbPopover]="convertPlanMsg"></breeze-button>
    </div>
  </div>
</div>
<ng-template #convertPlanMsg>
  <div class="message-delete">
    <p>{{warningMessageText()}} </p>
  </div>
  <div class="button-response">
    <breeze-button [isSecondary]="true" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
    <breeze-button [isPrimary]="true" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="submit()"></breeze-button>
  </div>
</ng-template>
